module.exports = __webpack_public_path__ + "static/media/menu-overlay-home.8048ab8f.jpg";